import { Kefir as K } from "kefir";
import { query } from "@standard-library/q-prime";
import any from "ramda/src/any";
import intersection from "ramda/src/intersection";
import Unknot from "@standard-library/unknot";
import without from "ramda/src/without";

import hovered from "./hovered";

export default context => {
  const loaded = K.fromEvents(context, "DOMContentLoaded");
  const mutations = K.stream(emitter => {
    const observer = new MutationObserver(ms => {
      emitter.emit(ms);
    });

    loaded.observe(() => {
      observer.observe(document.body, { childList: true, subtree: true });
    });

    return () => {
      observer.disconnect();
    };
  });

  const rendered = K.merge([loaded, mutations]);
  const o = Unknot(rendered, {
    member: {
      propertyBy: element => (sample, property) =>
        element.sampledBy(K.merge([element, sample])).map(e => e[property])
    },
    list: {
      events: elements => name =>
        elements.flatMapLatest(es =>
          K.merge(es.map(e => K.fromEvents(e, name)))
        ),
      onlyApply: elements => (on, off, current) => {
        const inactive = K.combine([current, elements], (e, es) =>
          without([e], es)
        );

        const active = K.combine([current, elements], (e, es) =>
          intersection([e], es)
        );

        active.flatten().observe(on);
        inactive.flatten().observe(off);
      },
      indicate: elements => (className, active) => {
        elements.onlyApply(
          e => e.classList.add(className),
          e => e.classList.remove(className),
          active
        );
      },
      hovered: elements => {
        return elements.flatMapLatest(es =>
          K.combine(
            es.map(e => hovered(o.wrap(K.constant(e))).map(h => (h ? e : null)))
          )
            .map(hs => hs.filter(h => h !== null)[0])
            .toProperty()
            .skipDuplicates()
        );
      },
      indicateUnits: elements => locations => {
        K.combine([elements, locations]).observe(([es, ls = []]) => {
          // Cop-out
          const $active = jQuery(es).filter((i, e) => {
            return any(l => `unit-${l}` === e.id, ls);
          });

          const $inactive = jQuery(es).not($active);

          $active.css('opacity', 1);
          $inactive.css('opacity', 0);
        });
      }
    }
  });

  o.loaded = loaded;

  return o;
};



// WEBPACK FOOTER //
// ./app/javascript/modules/dom.js